/**
 * RL-1644: the prescriber's name without a leading "Dr" / "Dr." title, so
 * the label's "Dr {{name}}" never reads "Dr Dr Farah Aziz".
 */
export function withoutDoctorTitle(name: string): string {
  return name.replace(/^\s*dr\.?\s+/i, '').trim() || name;
}
